/// <reference types="@angular/localize" />
import { bootstrapApplication } from '@angular/platform-browser';
import { MainComponent } from './app/pages/core/main/page/main.component';
import { coreConfig } from './app/pages/core/core.config';


bootstrapApplication(MainComponent, coreConfig)
  .catch(err => console.error(err));
